import { __read } from "tslib";
import { useContext, useState } from 'react';
import { canUseDom } from '../dom-utils';
import { SSRContext, initialContextValue } from '../ssr';
/**
 * React-hook for generate uniq identifier.
 *
 * When using ssr in a project, you must wrap the application in
 * `SSRProvider` for id synchronization between the server and the client.
 *
 * @param customId - Custom uniq id
 *
 * @example
 * const id = useUniqId()
 */
export function useUniqId(customId) {
    var context = useContext(SSRContext);
    var _a = __read(useState(function () { return "xuniq-" + context.id + "-" + ++context.value; }), 1), id = _a[0];
    console.assert(canUseDom || context !== initialContextValue, 'When using ssr in a project, you must wrap the application in <SSRProvider>' +
        ' for id synchronization between the server and the client.');
    return customId || id;
}
